import { useCoreStore } from '../../stores/core';
import { ICommand } from '../contracts/ICommand';

export class DisplaySubtitleCommand implements ICommand {
  constructor(private sentence: string) {}
  async execute(): Promise<void> {
    useCoreStore.getState().htCoreManager.displaySubtitle(this.sentence);
  }
}
